import React from 'react'
import classnames from 'classnames/bind'
import { Icon, Text } from '@adc/ui-adc'
import { TRIGGER_TEXT } from 'common/modules/bidHistory'
import styles from './styles.scss'
const cx = classnames.bind(styles)

export default props => {
  return (
    <div className={cx('u-pointer-cursor')} {...props}>
      <Icon color='info' name='history' fitted />
      <Text as='span' color='info' size='tiny' className='u-ml-1'>
        {TRIGGER_TEXT}
      </Text>
    </div>
  )
}
